// extracted by mini-css-extract-plugin
export default {"container":"OrganisationsUserPage_container__x7NKB","loaderContainer":"OrganisationsUserPage_loaderContainer__aKRw9"};